module.exports = __webpack_public_path__ + "media/flags/bi-aa8e3ffc.svg";